import { appName } from '@/utils/global.js'
export default {
    state: {
        appName: appName,  // 应用名称
        themeColor: localStorage.getItem('color') || "#14889A",  // 主题颜色
        oldThemeColor: "#14889A",   // 上一次主题颜色
        collapse:false,  // 导航栏收缩状态
        menuRouteLoaded:false,    // 菜单和路由是否已经加载
      /**
       *宋建国：2020/2/22 10:49
       *描述：记录拖拽时，路由路径，为了实现拖拽时路由跳转的页面，显示在拖拽操作区域，模拟正常运行页面,代表组件跟路由
       *版本：1.0
       */
        drapRoutePath: "",
      /**
       *宋建国：2020/2/4 17:26
       *描述：最新远程组件版本信息
       * 元素结构
       * {
       *     elementName: '组件元素名称',
       *     componentVersion: '版本号'
       * }
       *版本：1.0
       */
      remoteComponentVersion:[],
      /**
       *宋建国：2020/3/6 13:26
       *描述：拖拽容器实例this
       *版本：1.0
       */
      DragRouterViewThis: null,
      /**
	     *王伟东：2020/3/6 18:41
	     *描述：移动应用程序存储所有变量对象
	     *版本：1.0
	     */
      ApplicationData: {},
      routerLoadSuccess: 0,
    },
    getters: {
        collapse(state){// 对应着上面state
            return state.collapse
        },
      /**
       *宋建国：2020/3/6 13:27
       *描述：获取容器实例
       *版本：1.0
       */
        DragRouterViewThis(state) {
          return state.DragRouterViewThis;
        },
        /**
         *宋建国：2020/2/4 17:51
         *描述：对比组件是否是最新组件，如果版本相等则返回false,否则返回true,
         *版本：1.0
         */
        getComponentVersion: (state) => (eName,vsion) => {
          let result = true;
          for(let i=0; i < state.remoteComponentVersion.length; i++){
            if(state.remoteComponentVersion[i].componentName == eName &&
              state.remoteComponentVersion[i].componentVersion == vsion){
              result = false;
              break;
            }
          }
          return result;
        }
    },
    mutations: {
      /**
       *宋建国：2020/3/6 13:29
       *描述：设置拖拽容器实例
       *版本：1.0
       */
        setDragRouterViewThis(state,DragRouterViewThis) {
          state.DragRouterViewThis = DragRouterViewThis;
        },
        onCollapse(state){  // 改变收缩状态
            state.collapse = !state.collapse
        },
        setDrapRoutePath(state,path){ //设置跟路由
          if(path.charAt(0) === '/'){
            state.drapRoutePath = path.substring(1);
          }else{
            state.drapRoutePath = path;
          }
        },
        setThemeColor(state, themeColor){  // 改变主题颜色
            state.oldThemeColor = state.themeColor
            state.themeColor = themeColor
        },
        menuRouteLoaded(state, menuRouteLoaded){  // 改变菜单和路由的加载状态
          if(!menuRouteLoaded) state.routerLoadSuccess = 0
          else state.routerLoadSuccess = state.routerLoadSuccess + 1
          state.menuRouteLoaded = menuRouteLoaded;
        },
        setRouterLoadSuccess(state,num) {
          state.routerLoadSuccess = num || state.routerLoadSuccess + 1
        },
        /**
         *宋建国：2020/2/4 17:50
         *描述：设置最新组件版本信息
         *版本：1.0
         */
        setRemoteComponentVersion(state,ComponentVersion){
          state.remoteComponentVersion = ComponentVersion;
        },
       /**
       *王伟东：2020/3/6 18:41
       *描述：设置移动应用程序存储变量对象
       *版本：1.0
       */
        setApplicationData(state, obj) {
          state.ApplicationData[obj.key] = obj.value;
        }
    },
    actions: {
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js